import * as React from "react";
import { cn } from "@babackapp/customer-ui/lib/utils";

interface CustomerUiProviderProps {
  children?: React.ReactNode;
  className?: string;
  colors?: {
    primary?: string;
  };
  fonts?: {
    sans?: string;
  };
  customCssUrl?: string;
}

export function CustomerUiProvider({ children, className, colors, fonts, customCssUrl }: CustomerUiProviderProps) {
  React.useEffect(() => {
    if (!customCssUrl) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = customCssUrl;
    document.head.appendChild(link);
    return () => link.remove();
  }, [customCssUrl]);

  const style: React.CSSProperties = {
    ...(colors?.primary && { "--primary": colors.primary } as React.CSSProperties),
    ...(fonts?.sans && { "--font-sans": fonts.sans } as React.CSSProperties),
  };

  return (
    <div className={cn("cui", className)} style={style}>
      {children}
    </div>
  );
}
